var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('footer',{staticClass:"FooterClass",attrs:{"id":"footerComponent"}},[_c('p'),_c('div',{staticClass:"links"})])])}
var staticRenderFns = []

export { render, staticRenderFns }